import React, { useState } from "react";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import SoftInput from "StyleFeatures/SoftInput";
import SoftButton from "StyleFeatures/SoftButton";
import CoverLayout from "Common/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { error } from "highcharts";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError(null);

    // ✅ Email Validation
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError("Valid email required");
      return;
    }

    try {
      setIsLoading(true);

      // ✅ DIRECT API CALL (your requirement)
      const res = await axiosInstance.post(API.auth.forgetPassword, {
        email: email,
      });

      const data = res?.data;
      // ✅ Handle backend failure even if 200
      if (data?.success === false) {
        console.error("Request failed", error);
        throw new Error(data.message || "Request failed");
      }

      toast.success(data?.message || "Password reset link sent to your email");
      navigate("/check-email");

      // ✅ Optional UX reset
      setEmail("");
    } catch (err) {
      console.error("Forgot password error:", err);
      const msg = err.response?.data?.message || err.message || "Something went wrong";

      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CoverLayout
      title="Forgot Password"
      description="Enter your email to receive reset link"
      image={curved9}
    >
      <SoftBox component="form" onSubmit={handleSubmit}>
        <ToastContainer position="top-left" />

        {/* Email */}
        <SoftBox mb={2}>
          <SoftTypography variant="caption" fontWeight="bold">
            Email
          </SoftTypography>

          <SoftInput
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError(null);
            }}
            className={`form-control ${emailError ? "is-invalid" : ""}`}
          />

          {emailError && (
            <SoftTypography color="error" variant="caption">
              {emailError}
            </SoftTypography>
          )}
        </SoftBox>

        {/* Submit */}
        <SoftButton type="submit" fullWidth variant="gradient" color="info">
          {isLoading ? "Sending..." : "Send Reset Link"}
          {isLoading && (
            <span className="spinner-border spinner-border-sm" style={{ marginLeft: "8px" }} />
          )}
        </SoftButton>
      </SoftBox>
    </CoverLayout>
  );
}

export default ForgotPassword;
